var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 896,
    height: 346,
    viewBox: "0 0 896 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1048.61 1C961.499 13.115 824.921 37.6328 894.403 115.029C982.825 213.521 1198.9 187.719 1102.93 263.739",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.29 18.8774C937.181 30.9925 800.603 55.5102 870.085 132.907C958.506 231.399 1174.58 205.597 1078.61 281.616",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.822 35.3391C911.708 47.4541 775.13 71.9719 844.612 149.368C933.034 247.861 1149.11 222.058 1053.14 298.078",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.068 49.9846C884.954 62.0996 748.376 86.6174 817.858 164.014C906.28 262.506 1122.35 236.704 1026.39 312.723",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.978 62.3389C856.864 74.4539 720.286 98.9716 789.769 176.368C878.19 274.86 1094.26 249.058 998.298 325.078",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.64 71.9224C827.526 84.0374 690.948 108.555 760.431 185.951C848.852 284.444 1064.93 258.642 968.96 334.661",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.31 78.3975C797.196 90.5125 660.618 115.03 730.101 192.427C818.522 290.919 1034.6 265.117 938.63 341.136",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.386 81.7332C766.273 93.8482 629.694 118.366 699.177 195.762C787.598 294.255 1003.67 268.452 907.706 344.472",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.255 82.2612C735.142 94.3762 598.563 118.894 668.046 196.29C756.467 294.783 972.541 268.98 876.576 345",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.173 80.5652C704.06 92.6802 567.481 117.198 636.964 194.594C725.385 293.087 941.459 267.284 845.494 343.304",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.24 77.3018C673.126 89.4168 536.548 113.935 606.03 191.331C694.452 289.823 910.526 264.021 814.56 340.04",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.443 73.0745C642.329 85.1895 505.751 109.707 575.233 187.104C663.655 285.596 879.729 259.794 783.763 335.813",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.732 68.3809C611.618 80.4959 475.04 105.014 544.523 182.41C632.944 280.902 849.018 255.1 753.052 331.12",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.029 63.6084C580.915 75.7234 444.337 100.241 513.819 177.638C602.241 276.13 818.315 250.328 722.349 326.347",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.289 59.0493C550.175 71.1643 413.597 95.6821 483.079 173.078C571.501 271.571 787.575 245.769 691.609 321.788",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.478 54.9175C519.364 67.0325 382.786 91.5503 452.269 168.947C540.69 267.439 756.764 241.637 660.798 317.656",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.583 51.3655C488.47 63.4805 351.892 87.9983 421.374 165.395C509.795 263.887 725.87 238.085 629.904 314.104",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.603 48.4966C457.489 60.6116 320.911 85.1294 390.394 162.526C478.815 261.018 694.889 235.216 598.923 311.235",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.359 46.3494C426.245 58.4644 289.667 82.9821 359.15 160.378C447.571 258.871 663.645 233.069 567.679 309.088",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.275 44.6968C395.161 56.8118 258.583 81.3296 328.066 158.726C416.487 257.218 632.561 231.416 536.595 307.435",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.169 43.457C364.056 55.572 227.478 80.0898 296.96 157.486C385.381 255.978 601.455 230.176 505.49 306.196",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.042 42.6868C332.929 54.8018 196.351 79.3195 265.833 156.716C354.254 255.208 570.329 229.406 474.363 305.425",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.908 42.457C301.794 54.572 165.216 79.0898 234.698 156.486C323.12 254.978 539.194 229.176 443.228 305.196",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.773 42.8586C270.659 54.9737 134.081 79.4914 203.564 156.888C291.985 255.38 508.059 229.578 412.093 305.597",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.662 44.0107C239.548 56.1258 102.97 80.6435 172.452 158.04C260.874 256.532 476.948 230.73 380.982 306.749",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.607 46.0747C208.493 58.1897 71.9151 82.7075 141.398 160.104C229.819 258.596 445.893 232.794 349.927 308.813",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.665 49.2766C177.552 61.3916 40.9736 85.9094 110.456 163.306C198.878 261.798 414.952 235.996 318.986 312.015",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.945 53.9436C146.831 66.0586 10.2529 90.5764 79.7354 167.973C168.157 266.465 384.231 240.663 288.265 316.682",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.654 60.5417C116.54 72.6568 -20.0381 97.1745 49.4444 174.571C137.866 273.063 353.94 247.261 257.974 323.28",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.251 69.3428C87.1377 81.4578 -49.4404 105.976 20.0421 183.372C108.463 281.864 324.538 256.062 228.572 332.081",
    stroke: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRWaves);
export default __webpack_public_path__ + "static/media/R-waves.018397bbe49c73e541771c4cf9e91a92.svg";
export { ForwardRef as ReactComponent };